import React, { useRef, useEffect } from 'react';
import MaterialIcon from '@/components/MaterialIcon';

interface VideoModalProps {
  isOpen: boolean;
  src: string;
  onClose: () => void;
}

/**
 * VideoModal组件
 * 视频播放Modal,模拟手机外壳设计
 *
 * 特性:
 * - 手机外壳设计 (圆角、刘海)
 * - 自动播放 + 循环
 * - 点击背景关闭
 * - ESC键关闭
 */
export const VideoModal: React.FC<VideoModalProps> = ({ isOpen, src, onClose }) => {
  const videoRef = useRef<HTMLVideoElement>(null);

  useEffect(() => {
    if (isOpen && videoRef.current && src) {
      videoRef.current.play().catch((err) => {
        console.warn('Video autoplay prevented:', err);
      });
    }
  }, [isOpen, src]);

  useEffect(() => {
    if (!isOpen && videoRef.current) {
      videoRef.current.pause();
    }
  }, [isOpen]);

  useEffect(() => {
    const handleEscape = (e: KeyboardEvent) => {
      if (e.key === 'Escape' && isOpen) {
        onClose();
      }
    };
    window.addEventListener('keydown', handleEscape);
    return () => window.removeEventListener('keydown', handleEscape);
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/80 z-50 flex items-center justify-center p-4" onClick={onClose}>
      <div className="relative max-w-sm w-full" onClick={(e) => e.stopPropagation()}>
        {/* Close Button */}
        <button onClick={onClose} className="absolute -top-12 right-0 text-white hover:text-gray-300 transition-colors">
          <MaterialIcon name="close" className="text-3xl" />
        </button>

        {/* Phone Frame */}
        <div className="bg-gray-900 rounded-[2.5rem] p-2 shadow-2xl">
          <div className="rounded-[2rem] overflow-hidden bg-black aspect-[9/19]">
            <video ref={videoRef} className="w-full h-full object-contain" loop muted playsInline controls src={src} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default VideoModal;
